module.exports = __webpack_public_path__ + "static/media/5.17c0074b.jpg";